"use client";
import React from "react";
import { Control, Controller } from "react-hook-form";
import styles from "./InputText.module.scss";

export type Props = {
  label: string;
  icon?: string;
  maxLength?: number;
  control: Control<any>;
  name: string;
  defaultValue?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const InputText = ({
  label,
  icon,
  maxLength,
  control,
  name,
  defaultValue,
  onChange,
}: Props) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <div
          className={`${styles.container}
            ${error ? styles.containerError : ""}`}
        >
          {icon && (
            <img src={icon} alt="icon for input" width={24} height={24} />
          )}
          <div className={styles.inputWrap}>
            <input
              className={styles.input}
              type="text"
              placeholder={label}
              maxLength={maxLength}
              {...field}
              defaultValue={defaultValue ? defaultValue : ""}
              onChange={(e) => {
                field.onChange(e);
                if (onChange) {
                  onChange(e);
                }
              }}
            />
          </div>
          {error && <div className={styles.error}>{error.message}</div>}
        </div>
      )}
    />
  );
};
